import SettingsModal from 'appToolbar/SettingsModal';
import React, { useCallback } from 'react';
import { useReferredState } from '@instinet-analytics/core-lib';

export interface ConfigSettingsProps<TConfigState> {
    onChange?: (nextDelta: Partial<TConfigState>) => void;
}

export interface ConfigSettingsModalProps<TConfigState> {
    className?: string;
    dispatcher: (configDelta: Partial<TConfigState>) => void;
    triggerText: string;
    headerText: string;
    renderSettings: React.FC<ConfigSettingsProps<TConfigState>>;
}

export default function ConfigSettingsModal<TConfigState>(
    props: ConfigSettingsModalProps<TConfigState>
) {
    const { className, dispatcher, headerText, renderSettings, triggerText } =
        props;
    const [, deltaRef, setDelta] = useReferredState<Partial<TConfigState>>({});

    const onChange = useCallback((nextDelta: Partial<TConfigState>) => {
        const cumulativeDelta = { ...deltaRef.current, ...nextDelta };
        setDelta(cumulativeDelta);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const saveChanges = () => {
        dispatcher(deltaRef.current);
    };

    return (
        <SettingsModal
            className={className}
            trigger={<span>{triggerText}</span>}
            headerText={headerText}
            saveText="OK"
            onOpen={() => {
                return;
            }}
            onCancel={() => {
                return;
            }}
            onSave={() => {
                saveChanges();
                return;
            }}
        >
            {renderSettings({ onChange })}
        </SettingsModal>
    );
}
